import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const defaultLocale = 'ja'

const ja = Object.assign(
  require('@/locales/ja.json'),
  require('@/locales/pages/ja.json')
)

const i18n = new VueI18n({
  locale: defaultLocale,
  messages: {
    'ja': ja
  }
})

export default i18n
